module.exports = __webpack_public_path__ + "static/media/MAI.db13df23.png";